import React, { useState } from 'react';
import { View, ScrollView, Pressable } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { useAppSelector } from '../hooks';
import { themeMenuContent } from '../styles';
import { TreeView, TreeNode, FlatlistMenu, BText } from '.';

type Props = {
  menuTitle?: string;
  menus: TreeNode[];
};
export const SideMenus = ({ menuTitle = 'Menu', menus }: Props) => {
  const rtPortal = useAppSelector(s => s.portal);
  const [showMenu, setShowMenu] = useState<boolean>(true);

  return (
    <>
      {rtPortal.isSmallScreen && (
        <View>
          <Pressable onPress={() => setShowMenu(!showMenu)}>
            <BText style={themeMenuContent.menuButton}>
              <FontAwesomeIcon icon={faBars} size={'xl'} style={themeMenuContent.menuButtonIcon} />
              {menuTitle}
            </BText>
          </Pressable>
        </View>
      )}
      {(showMenu || !rtPortal.isSmallScreen) && (
        <ScrollView
          style={[rtPortal.isSmallScreen ? themeMenuContent.menuContainerSM : themeMenuContent.menuContainer]}
        >
          {rtPortal.isSmallScreen && <FlatlistMenu nodes={menus} onClose={() => setShowMenu(false)} />}
          {!rtPortal.isSmallScreen && <TreeView nodes={menus} />}
        </ScrollView>
      )}
    </>
  );
};
